import React, { useState } from 'react';
import { Phone, Mail, X } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}) {
  return <AnimatePresence data-id="element-101">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={onClose} data-id="element-102">
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.2
      }} className="bg-white rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-hidden shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-103">
            <div className="flex items-center justify-between p-6 border-b border-gray-100" data-id="element-104">
              <h2 className="text-xl font-bold text-[#1B2E1B]" data-id="element-105">{title}</h2>
              <button onClick={onClose} className="p-2 rounded-lg hover:bg-gray-100 transition-colors text-gray-500" data-id="element-106">
                <X className="w-5 h-5" data-id="element-107" />
              </button>
            </div>
            <div className="p-6 overflow-y-auto max-h-[60vh] text-gray-600 text-sm leading-relaxed space-y-4" data-id="element-108">
              {children}
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="bg-[#1B2E1B] text-gray-400 py-12 border-t border-white/10" data-id="element-109">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center text-center" data-id="element-110">
          <img src="https://cdn.magicpatterns.com/uploads/8UAMqXX221Y2fkV41Qc9pU/Photoroom_20260321_140530.png" alt="RMorales Lawn Service LLC" className="h-28 md:h-36 w-auto mb-4" data-id="element-111" />

          <div className="flex flex-col sm:flex-row gap-3 sm:gap-6 mb-4" data-id="element-112">
            <a href="tel:8325034445" className="flex items-center gap-2 text-[#C5A55A] font-bold text-xl hover:text-white transition-colors" data-id="element-113">
              <Phone className="w-5 h-5" data-id="element-114" />
              832-503-4445
            </a>
            <a href="tel:8327594597" className="flex items-center gap-2 text-[#C5A55A] font-bold text-xl hover:text-white transition-colors" data-id="element-115">
              <Phone className="w-5 h-5" data-id="element-116" />
              832-759-4597
            </a>
          </div>

          <a href="mailto:rmoralesjose06@gmail.com" className="flex items-center gap-2 text-gray-400 hover:text-[#C5A55A] transition-colors mb-8" data-id="element-117">
            <Mail className="w-4 h-4" data-id="element-118" />
            rmoralesjose06@gmail.com
          </a>

          <div className="w-full border-t border-white/10 pt-8 text-sm" data-id="element-119">
            <p data-id="element-120">
              &copy; {new Date().getFullYear()} RMorales Lawn Service LLC. All
              rights reserved.
            </p>
            <div className="flex items-center justify-center gap-4 mt-4" data-id="element-121">
              <button onClick={() => setShowPrivacy(true)} className="text-gray-500 hover:text-[#C5A55A] transition-colors cursor-pointer" data-id="element-122">
                Privacy Policy
              </button>
              <span className="text-gray-600" data-id="element-123">•</span>
              <button onClick={() => setShowTerms(true)} className="text-gray-500 hover:text-[#C5A55A] transition-colors cursor-pointer" data-id="element-124">
                Terms of Service
              </button>
            </div>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <LegalModal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Privacy Policy" data-id="element-125">
        <p data-id="element-126">
          <strong data-id="element-127">Last updated:</strong> January 2025
        </p>
        <p data-id="element-128">
          RMorales Lawn Service LLC ("we," "us," or "our") respects your
          privacy. This Privacy Policy explains how we collect, use, and protect
          your personal information when you use our website or services.
        </p>
        <p data-id="element-129">
          <strong data-id="element-130">Information We Collect</strong>
        </p>
        <p data-id="element-131">
          We may collect personal information you provide directly, such as your
          name, phone number, email address, and property address when you
          request a quote or contact us.
        </p>
        <p data-id="element-132">
          <strong data-id="element-133">How We Use Your Information</strong>
        </p>
        <p data-id="element-134">
          We use your information to respond to inquiries, provide lawn care
          services, send service-related communications, and improve our website
          and services.
        </p>
        <p data-id="element-135">
          <strong data-id="element-136">Information Sharing</strong>
        </p>
        <p data-id="element-137">
          We do not sell, trade, or rent your personal information to third
          parties. We may share information with trusted service providers who
          assist us in operating our business.
        </p>
        <p data-id="element-138">
          <strong data-id="element-139">Data Security</strong>
        </p>
        <p data-id="element-140">
          We implement reasonable security measures to protect your personal
          information. However, no method of transmission over the internet is
          100% secure.
        </p>
        <p data-id="element-141">
          <strong data-id="element-142">Contact Us</strong>
        </p>
        <p data-id="element-143">
          If you have questions about this Privacy Policy, please contact us at
          rmoralesjose06@gmail.com or call 832-503-4445.
        </p>
      </LegalModal>

      {/* Terms of Service Modal */}
      <LegalModal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Terms of Service" data-id="element-144">
        <p data-id="element-145">
          <strong data-id="element-146">Last updated:</strong> January 2025
        </p>
        <p data-id="element-147">
          Welcome to RMorales Lawn Service LLC. By using our website and
          services, you agree to the following terms and conditions.
        </p>
        <p data-id="element-148">
          <strong data-id="element-149">Services</strong>
        </p>
        <p data-id="element-150">
          RMorales Lawn Service LLC provides lawn care, landscaping, and related
          outdoor maintenance services in the greater Houston, Texas area. All
          services are subject to availability and scheduling.
        </p>
        <p data-id="element-151">
          <strong data-id="element-152">Quotes & Pricing</strong>
        </p>
        <p data-id="element-153">
          All quotes provided are estimates based on the information available
          at the time. Final pricing may vary based on actual property
          conditions, scope of work, and materials required.
        </p>
        <p data-id="element-154">
          <strong data-id="element-155">Cancellations</strong>
        </p>
        <p data-id="element-156">
          We appreciate advance notice for cancellations. Please contact us at
          least 24 hours before your scheduled service to cancel or reschedule
          without any fees.
        </p>
        <p data-id="element-157">
          <strong data-id="element-158">Liability</strong>
        </p>
        <p data-id="element-159">
          RMorales Lawn Service LLC is fully committed to providing quality
          service. We are not liable for pre-existing property conditions,
          underground utilities, or damage caused by factors beyond our control.
        </p>
        <p data-id="element-160">
          <strong data-id="element-161">Contact Us</strong>
        </p>
        <p data-id="element-162">
          For questions about these Terms of Service, please contact us at
          rmoralesjose06@gmail.com or call 832-503-4445.
        </p>
      </LegalModal>
    </>;
}